import type { CSETextarea } from '@cloudsuite/mosaic-elements'
import { html, LitElement, type CSSResultGroup, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'

@customElement('csc-basket-line-memo')
export class CSCBasketLineMemo extends LitElement {
  static override styles: CSSResultGroup = [hostStyle]

  @property({ attribute: 'maximum-characters', type: Number })
  public maximumCharacters?: number

  @property()
  public value = ''

  private get characterLimit() {
    return this.maximumCharacters && this.maximumCharacters > 0 ? this.maximumCharacters : 0
  }

  private handleChange = (e: Event) => {
    this.value = (e.target as CSETextarea).value
  }

  override render() {
    return html`
      <cse-form-field>
        <cse-label slot="label">
          <slot name="label">${t('label', { ns: 'csc-basket-line-memo', default: 'Memo' })}</slot>
        </cse-label>
        <cse-textarea
          id="memo"
          name="memo"
          .value="${this.value}"
          maxlength=${this.characterLimit || nothing}
          @change="${this.handleChange}"
        ></cse-textarea>
      </cse-form-field>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-basket-line-memo': CSCBasketLineMemo
  }
}
